import { useState } from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import { FiMenu, FiX } from "react-icons/fi";
import group from "../assets/admin/Group 87-2.svg";
import group2 from "../assets/admin/Group.svg";
import group3 from "../assets/admin/Group 89.svg";
import logo from "../assets/tweezers.svg";
import group4 from "../assets/admin/Group-2.svg";
import { useNavigate } from "react-router-dom";

const DashboardContainer = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const links = [
    { name: "Dashboard", href: "/twzpanel/dashboard", icon: group },
    { name: "All Users", href: "/twzpanel/dashboard/users", icon: group2 },
    { name: "Push Campaigns", href: "/twzpanel/dashboard/push-campaigns", icon: "/src/assets/admin/Group 90.svg" },
    { name: "Predict & Win", href: "/twzpanel/dashboard/predictwin", icon: "/src/assets/admin/Group 90.svg" },
    { name: "Crypto Payments", href: "/twzpanel/crypto-requests", icon: "/src/assets/admin/Group 91.svg" },
    { name: "Transaction History", href: "/twzpanel/dashboard/transaction-history", icon: group3 },
  ];

  const navigate = useNavigate();

  const handleLogout = async () => {
    localStorage.removeItem("admin_token");
    navigate("/twzpanel");
  }

  return (
    <div className="min-h-screen flex font-sora">
      {/* Mobile Menu Button */}
      <button
        className="md:hidden fixed top-4 left-4 z-50 text-white bg-secondary p-2 rounded-lg"
        onClick={() => setIsSidebarOpen(!isSidebarOpen)}
      >
        {isSidebarOpen ? <FiX size={24} /> : <FiMenu size={24} />}
      </button>

      {/* Sidebar */}
      <aside
  className={`w-72 bg-secondary text-white flex flex-col p-6 h-screen fixed md:sticky top-0 md:block z-40 transition-transform duration-300 md:translate-x-0 ${
    isSidebarOpen ? "translate-x-0" : "-translate-x-full"
  }`}
>
        <div className="py-6 px-4">
          <img
            src={logo}
            alt="Logo"
            className="p-2 animate__animated animate__lightSpeedInLeft"
          />
        </div>
        <nav className="flex-1 px-2 space-y-6 mt-12 text-[14px] text-nene">
          {links.map((link) => (
            <NavLink
              key={link.href}
              to={link.href}
              end
              className={({ isActive }) =>
                `flex items-center px-4 py-2 rounded-xl ${
                  isActive
                    ? "bg-primary text-secondary font-semibold"
                    : "hover:bg-purple-200"
                }`
              }
            >
              <img src={link.icon} alt="icon" className="size-4" />
              <span className="ml-3">{link.name}</span>
            </NavLink>
          ))}
          <div
            onClick={handleLogout}
            className="text-red-500 flex items-center px-4 py-2 hover:bg-purple-200 rounded-md cursor-pointer"
          >
            <img src={group4} alt="icon" className="size-4" />
            <span className="ml-3">Log Out</span>
          </div>
        </nav>
      </aside>

      {/* Main Content */}
      <main className="flex-1 bg-gray-100 p-6 md:ml-0">{children}</main>
      </div>
  );
};

DashboardContainer.propTypes = {
  children: PropTypes.node.isRequired,
};

export default DashboardContainer;
